// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3WJyz","balanceDisclaimer":"posDashboard_balanceDisclaimer__1DW0F"};